import React, { useRef } from 'react';
import { Input, Label, FormGroup, InputProps } from 'reactstrap';

interface ICheckbox extends InputProps {
  labelBold?: boolean;
  label?: string | JSX.Element;
  classNameWrap?: string;
  description?: JSX.Element | string;
}

const Checkbox = ({
  label,
  labelBold = false,
  classNameWrap,
  indeterminate,
  description,
  innerRef,
  ...attributes
}: ICheckbox): JSX.Element => {
  const inputRef = useRef<
    | (HTMLInputElement & { indeterminate: boolean })
    | (HTMLTextAreaElement & { indeterminate: boolean })
  >(null);

  if (typeof indeterminate === 'boolean' && inputRef.current) {
    inputRef.current.indeterminate = indeterminate;
  }

  return (
    <>
      {label ? (
        <FormGroup check className={classNameWrap}>
          <Input {...attributes} type="checkbox" innerRef={innerRef || inputRef} />
          <Label htmlFor={attributes.id} check>
            {labelBold ? <strong>{label}</strong> : label}
          </Label>
        </FormGroup>
      ) : (
        <Input {...attributes} type="checkbox" innerRef={innerRef || inputRef} />
      )}
      {!!description && <div className="form-check-description">{description}</div>}
    </>
  );
};

export default Checkbox;
